import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M20.169 9.306c.377.955.578 1.986.578 3.068a8.37 8.37 0 0 1-8.373 8.373A8.37 8.37 0 0 1 4 12.374C4 7.872 7.546 4.2 12.022 4c0 0 0 .1.075 6.312.075 6.236-3.219 5.758-3.143 3.218.05-1.81 8.55-1.156 8.55-1.156"
    />
    <path
      strokeDasharray="2.4 2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M14.54 4.285a8.36 8.36 0 0 1 5.598 4.949"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const ClockIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
